import { useEffect, useState } from 'react';
import { supabase } from '../../api/apiService';

interface RecipeImageRealtimePayload {
  new: {
    id: string;
    image?: string | null;
  };
}

export const useRecipeImageRealtime = (
  recipeId?: string,
  initialImageUrl: string | null = null
): string | null => {
  const [currentImageUrl, setCurrentImageUrl] = useState<string | null>(initialImageUrl);

  useEffect(() => {
    setCurrentImageUrl(initialImageUrl);
  }, [initialImageUrl]);

  useEffect(() => {
    if (!recipeId) {
      return;
    }

    const channel = supabase
      .channel(`public_recipe_image_update:${recipeId}`)
      .on(
        'postgres_changes',
        { event: 'UPDATE', schema: 'public', table: 'recipes', filter: `id=eq.${recipeId}` },
        (payload: RecipeImageRealtimePayload) => {
          const nextImageUrl = payload.new.image;

          if (nextImageUrl !== undefined) {
            setCurrentImageUrl((previousImageUrl) => (
              previousImageUrl === nextImageUrl ? previousImageUrl : nextImageUrl
            ));
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [recipeId]);

  return currentImageUrl;
};

export default useRecipeImageRealtime;
